import { createSelector } from 'reselect'

const getCustomFields = (customFields, role, association, projectId) => customFields
    .filter(customField =>
        !customField.removed &&
        (!association || customField.associations.includes(association)) &&
        (role === 'owner' || !customField.hidden.includes(role)) &&
        (!projectId || customField.projects.includes(projectId))
    );
export const makeGetCustomFields = () => createSelector(getCustomFields, customFields => customFields);

const getLibraryCustomFields = (customFields, role, association, projectId) => customFields
    .filter(customField =>
        !customField.removed &&
        customField.in_library &&
        (!association || customField.associations.includes(association)) &&
        (role === 'owner' || !customField.hidden.includes(role)) &&
        !(projectId || customField.projects.includes(projectId))
    );
export const makeGetLibraryCustomFields = () => createSelector(getLibraryCustomFields, customFields => customFields);

const getCustomField = (customFields, id) => customFields.find(customField => customField.id === id);
export const makeGetCustomField = () => createSelector(getCustomField, customField => customField);
